import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { Http } from '@angular/http';
import CustomStore from 'devextreme/data/custom_store';
import { NTECH_API } from './../app.api';
import { GridConfig, calculaAlturaGrid, adicionaIconesGrid } from './../app.config';
import { DxDataGridModule, DxDataGridComponent } from 'devextreme-angular';
import { PaisService } from '../pais/pais.service'

@Component({
  selector: 'ntc-estado',
  templateUrl: './estado.component.html',
  styleUrls: ['./estado.component.css']
})
export class EstadoComponent implements OnInit {
  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;

  editOptionsGridEstado = null;
  colunasGridEstado = null;
  estado = null;
  listaPais = null;
  alturaGrid = null;

  showFilterRow = GridConfig.showFilterRow;
  currentFilter = GridConfig.currentFilter;
  showHeaderFilter = GridConfig.showHeaderFilter;
  columnChooser = GridConfig.columnChooser;
  groupPanel = GridConfig.groupPanel;
  searchPanel = GridConfig.searchPanel;
  exportGrid = GridConfig.exportGrid;

  constructor(
    @Inject(Http) http: Http,
    private paisService: PaisService
  ) {

    this.estado = new CustomStore({
      insert: function (values) {
        return http.post(`${NTECH_API}/estado/`, values).toPromise();
      },
      remove: function (key) {
        return http.delete(`${NTECH_API}/estado/${encodeURIComponent(key.Id)}`).toPromise();
      },
      update: function (key, values) {     
        return http.put(`${NTECH_API}/estado/${encodeURIComponent(key.Id)}`, Object.assign(key,values)).toPromise();
      },
      load: function (loadOptions: any) {
        return http.get(`${NTECH_API}/estado/`)
            .toPromise()
            .then(response => response.json())
            .catch(error => { throw 'Erro ao carregar dados.' });
      }
    });

    this.colunasGridEstado = [
      {
        dataField: 'Id',
        dataType: 'string',
        caption: 'ID',
        editorOptions: { disabled: true }
      },
      {
        dataField: 'DDD',
        dataType: 'string',
        caption: 'DDD',
        validationRules: [{
          type: 'required',
          message: 'DDD do Estado é obrigatório.'
        }]
      },
      {
        dataField: 'NomeEstado',
        dataType: 'string',
        caption: 'Nome do Estado',
        validationRules: [{
          type: 'required',
          message: 'Nome do Estado é obrigatório.'
        }]
      },
      {
        dataField: 'SiglaEstado',
        dataType: 'string',
        caption: 'Sigla do estado',
        validationRules: [{
          type: 'required',
          message: 'Sigla do Estado é obrigatória.'
        }]
      },
    ];

    this.editOptionsGridEstado = {
      mode: GridConfig.gridMode, // form
      allowUpdating: true,
      allowAdding: true,
      allowDeleting: true,
      popup: {
        title: 'Estado',
        showTitle: true
      }
    };
  }

  onCellPrepared(e) {
    adicionaIconesGrid(e);
  }

  onToolbarPreparing(e) {
    const toolbarItems = e.toolbarOptions.items;

    // Adiciona um novo botao a Toolbar
    toolbarItems.push({
      location: 'after',
      widget: 'dxButton',
      options: {
          icon: 'refresh',
          onClick: this.refreshDataGrid.bind(this)
      }
    });
  }

  refreshDataGrid() {
    this.dataGrid.instance.refresh();
  }

  ngOnInit() {
    this.alturaGrid = calculaAlturaGrid();
    // Carrega lista de paises para popular select-box 
    // Adiciona "obj" do select-box na lista de colunas da grid 
    this.paisService.getPaises().subscribe(paises => {
      this.listaPais = paises;

      const selectPais = {
        dataField: 'IdPais',
        caption: 'Pais',
        width: 125,
        lookup: {
            dataSource: this.listaPais,
            displayExpr: 'NomePais',
            valueExpr: 'Id'
        },
        validationRules: [{
          type: 'required',
          message: 'País é obrigatório.'
        }]
      };

      this.colunasGridEstado.push(selectPais);
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/estado/estado.component.ts